export default "__VITE_ASSET__CtpT6EtF__"